export default {
	'component.signup.newhousing': 'Gratulerer med nye boliger',
	'component.signup.createpwd': 'Lag passord',
	'component.signup.readcontract': 'Les utkast til kontrakt',
	'component.signup.entercomment': 'Skriv inn kommentar her ...',	
	'component.signup.thankyou': 'Thanak-yau re nova donne!',	
}